// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer{
    position: absolute;
    z-index: 2;
    width: 100%;
}
.footer_top{
    display: flex;
    flex-direction: column;
    z-index: 2;
    padding: 1.5rem 5rem;
    gap: 0.5rem;
}
.footer_top_left{
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    gap: 1rem;
}
.linkFooter{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:smaller
}
@media only screen and (max-width: 800px) {
    .footer_top{
        flex-direction: column;
        padding: 1rem 3rem;
        gap: 1rem;
        
    }
    .footer_top_right{
        gap: 0.5rem;
    }
    .footer_top_left{
        gap: 1rem;
    }
}
@media only screen and (max-width: 550px) {
    .footer_top{
        padding-left: 2rem;
        padding-right: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,oBAAoB;IACpB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;;IAEb;IACA;QACI,WAAW;IACf;IACA;QACI,SAAS;IACb;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ","sourcesContent":[".footer{\n    position: absolute;\n    z-index: 2;\n    width: 100%;\n}\n.footer_top{\n    display: flex;\n    flex-direction: column;\n    z-index: 2;\n    padding: 1.5rem 5rem;\n    gap: 0.5rem;\n}\n.footer_top_left{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n    gap: 1rem;\n}\n.linkFooter{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size:smaller\n}\n@media only screen and (max-width: 800px) {\n    .footer_top{\n        flex-direction: column;\n        padding: 1rem 3rem;\n        gap: 1rem;\n        \n    }\n    .footer_top_right{\n        gap: 0.5rem;\n    }\n    .footer_top_left{\n        gap: 1rem;\n    }\n}\n@media only screen and (max-width: 550px) {\n    .footer_top{\n        padding-left: 2rem;\n        padding-right: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
